export default __webpack_public_path__ + "images/14fc5d73a5fe9b8fec07b99112378eb8.png";